import React from 'react';
import { withRouter } from 'next/router';

const FacultyMember = (props) => {
	const faculty = props?.faculty[0];

	return (
		<div className='faculty'>
			<div className="container">
				<div className="dr-new">
					<div className="left">
						<a className='backbtn' href="javascript:;" onClick={() => props.router?.back()}>Back</a>
						{/* {(props.isLeader && props.isLeader.includes('leaders')) ? <Link href='/leaders' ><a className='backbtn'>Back</a></Link> : <Link href='/faculty' ><a className='backbtn'>Back</a></Link>} */}
						<img src={`${process.env.CMS_API_ORIGIN}${faculty?.image?.url}`} alt={faculty?.full_name} />
						<h5>{faculty?.full_name}</h5>
					</div>
					<div className="right">
						<h2>{faculty?.full_name}</h2>
						<p>{faculty?.title}</p>
						{/*<p dangerouslySetInnerHTML={{ __html: faculty?.bayan_designation || faculty?.designation }}></p>*/}
						<p dangerouslySetInnerHTML={{ __html: faculty?.bayan_designation || faculty?.school }}></p>
						{faculty?.email && <p>Bayan Email: {faculty?.email}</p>}
						{
							faculty?.biography.map((data,index)=> <p key={index} dangerouslySetInnerHTML={{ __html: data?.content ?? "" }} ></p>)
						}
					</div>
				</div>
			</div>
		</div>

	);
}




export default withRouter(FacultyMember);
